import {
  SET_STEP,
  ADD_TO_MULTI_FORM,
  REMOVE_FROM_MULTI_FORM,
  CLEAR_MULTI_FORM,
  SUBMIT_MULTI_FORM_START,
  SET_FORM,
  CLEAR_FORM
} from './action-types';

export const setForm = form => async dispatch => {
  dispatch({
    type: SET_FORM,
    payload: { form }
  });
};

export const clearForm = () => async dispatch => {
  dispatch({
    type: CLEAR_FORM
  });
};

export const setStep = step => async dispatch => {
  dispatch({
    type: SET_STEP,
    payload: { step }
  });
};

export const addToMultiForm = (id, form) => async dispatch => {
  dispatch({
    type: ADD_TO_MULTI_FORM,
    payload: { id, form }
  });
};

export const removeFromMultiForm = id => async dispatch => {
  dispatch({
    type: REMOVE_FROM_MULTI_FORM,
    payload: { id }
  });
};

export const clearMultiForm = () => async dispatch => {
  dispatch({
    type: CLEAR_MULTI_FORM
  });
};

export const submitMultiForm = payload => async dispatch => {
  dispatch({
    type: SUBMIT_MULTI_FORM_START,
    payload
  });
};
